// extracted by css-extract-rspack-plugin
var _1 = "li";
var _2 = "h";
var _3 = "lx";
var _4 = "g";
var _5 = "b";
var _6 = "f";
export { _1 as "closeButton", _2 as "content", _3 as "informationModalComponent", _4 as "inner", _5 as "modalComponent", _6 as "wrapper" }
